import React from 'react'

const LoginDeleteItem = (props) => {

    return (
        <button onClick={props.deleteUser}>
            delete
        </button>
    )
}

export default LoginDeleteItem